<template>
    <main-content>
        <div class="bg-white border rounded p-4">
            <form id="password_form">
                <div class="row">
                    <div class="col-12 mt-2 mb-4">
                        <div class="back-flex">
                            <router-link to="/wallets" class="btn btn-success my-2 btn-width-100">{{
                                    $t('label.back')
                                }}
                            </router-link>
                        </div>
                        <span class="h5 my-2"
                              v-text="$t('label.set_access_password_for_settlement_and_transfer')"></span>
                    </div>
                    <div v-if="show_sms_verify"
                         class="col-12 col-md-6 my-3"
                    >
                        <label for="sms_verify"
                               v-text="$t('label.sms_verify')"
                        ></label>
                        <input name="sms_verify"
                               type="text"
                               id="sms_verify"
                               class="form-control"
                               v-model="form_data.sms_verify"
                        >
                    </div>
                    <div v-else
                         class="col-12 col-md-6 my-3"
                    >
                        <label for="old_password"
                               v-text="$t('label.old_password')"
                        ></label>
                        <div class="row">
                            <div class="col-1">
                                <button class="form-control"
                                        style="width: fit-content"
                                        type="button"
                                        @click="togglePassword('old_password')"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            <div class="col-11">
                                <input name="old_password"
                                       :type="old_password_type"
                                       id="old_password"
                                       class="form-control"
                                       v-model="form_data.old_password"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 my-3">
                        <label for="new_password"
                               v-text="$t('label.new_password_for_wallet')"
                        ></label>
                        <div class="row">
                            <div class="col-1">
                                <button class="form-control"
                                        style="width: fit-content"
                                        type="button"
                                        @click="togglePassword('new_password')"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            <div class="col-11">
                                <input name="new_password"
                                       :type="new_password_type"
                                       id="new_password"
                                       class="form-control"
                                       v-model="form_data.new_password"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-4">
                        <button type="button"
                                class="btn btn-success mx-2"
                                @click="changePassword()"
                                v-text="$t('btn.submit_changes')"
                        ></button>
                        <button type="button"
                                class="btn btn-primary mx-2"
                                @click="forgetPassword()"
                                v-text="$t('label.forget_wallet_old_password')"
                        ></button>
                    </div>
                </div>
            </form>
        </div>
        <div class="my-2" id="sign_key_form">
            <div class="row">
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.wallet_sign_key')"></span>
                        </div>
                        <div class="my-3">
                            <textarea name="sign_key"
                                      type="text"
                                      id="sign_key"
                                      dir="ltr"
                                      class="form-control"
                                      :value="sign_key"
                                      disabled
                                      rows="5"></textarea>
                            <!--                            <span v-text="$t('label.sign_key_needed_in_webservices')"></span>-->
                        </div>
                        <div class="mt-4">
                            <button type="button"
                                    class="btn btn-success mx-2"
                                    @click="regenerateSignKey()"
                                    v-text="$t('label.regenerate_sign_key')"
                            ></button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.api_key')"></span>
                        </div>
                        <div class="my-3" v-if="api_key == null">
                            <div class="col-12 my-3">
                                <span v-text="$t('label.api_key_has_been_expired')"></span>
                            </div>
                            <div class="col-12 mt-4">
                                <button type="button"
                                        class="btn btn-success mx-2"
                                        @click="regenerateApiKey()"
                                        v-text="$t('label.regenerate_api_key')"
                                ></button>
                            </div>
                        </div>
                        <div class="my-3" v-else>
                            <textarea
                                name="api_key"
                                type="text"
                                id="api_key"
                                dir="ltr"
                                class="form-control"
                                :value="api_key"
                                disabled
                                rows="5"
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.refresh_token')"></span>
                        </div>
                        <div class="my-3">
                            <textarea
                                name="refresh_token"
                                type="text"
                                id="refresh_token"
                                dir="ltr"
                                class="form-control"
                                :value="refresh_token"
                                disabled
                                rows="5"
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.inquiry_key')"></span>
                        </div>
                        <div class="my-3" v-if="inquiry_key == null">
                            <div class="col-12 my-3">
                                <span v-text="$t('label.inquiry_key_has_been_expired')"></span>
                            </div>
                            <div class="col-12 mt-4">
                                <button type="button"
                                        class="btn btn-success mx-2"
                                        @click="regenerateInquiryKey()"
                                        v-text="$t('label.regenerate_inquiry_key')"
                                ></button>
                            </div>
                        </div>
                        <div class="my-3" v-else>
                            <textarea
                                name="inquiry_key"
                                type="text"
                                id="inquiry_key"
                                dir="ltr"
                                class="form-control"
                                :value="inquiry_key"
                                disabled
                                rows="5"
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.refresh_inquiry_key')"></span>
                        </div>
                        <div class="my-3">
                            <textarea
                                name="refresh_inquiry_key"
                                type="text"
                                id="refresh_inquiry_key"
                                dir="ltr"
                                class="form-control"
                                :value="refresh_inquiry_key"
                                disabled
                                rows="5"
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p style="color: red">
            {{$t('label.inquiry_key_description')}}
        </p>

        <!--        settlement setting start -->
        <form class="my-2 bg-white rounded border p-4" id="settlement_setting">
            <div class="row align-items-baseline">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('label.settlement_setting')"></div>
                </div>
                <div class="col-12 col-md-6 my-2" v-show="false">
                    <div class="form-group">

                        <label class="switch">
                            <input
                                type="checkbox"
                                id="settlement_with_paya_when_bank_disable"
                                v-model="settlement_with_paya_when_bank_disable"
                            />
                            <span class="slider round"></span>
                        </label>
                        <label class="m-0 p-0 form-check-label pr-4" for="settlement_with_paya_when_bank_disable"
                               v-text="$t('wallets.label.settlement_with_paya_when_bank_disable')"></label>
                        <br>
                    </div>

                </div>
                <div class="col-12 col-md-6 my-2">
                    <div class="form-group">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <label class="switch">
                                    <input
                                        type="checkbox"
                                        id="settlement_two_factor_setting"
                                        v-model="settlement_two_factor_setting"
                                    />
                                    <span class="slider round"></span>
                                </label>
                                <label class="m-0 p-0 form-check-label pr-4" for="settlement_two_factor_setting"
                                       v-text="$t('wallets.label.settlement_two_factor')"></label>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-4">
                    <button class="btn btn-success" @click="settlementSettingAction()" :disabled="settlement_setting_loading" type="button">
                        <span>{{$t('btn.submit_changes')}}</span>
                        <span v-if="settlement_setting_loading" class="spinner-border spinner-border-sm p-2 mr-1"></span>
                    </button>
                </div>
            </div>
        </form>
        <password-modal
            :message="$t('label.enter_your_wallet_password')"
            @sendOtpCode="setWalletPasswordAndSendOtp"
        ></password-modal>
        <Approve
            :message="$t('label.input_verification_code')"
            :two_factor_type="two_factor_type"
            @emitAction="setOtp"
            @sendRequest="sendRequest"
        >
        </Approve>

        <!--        settlement setting end -->

        <form class="my-2 bg-white rounded border p-4" id="edit_data_form">
            <div class="row align-items-baseline">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('label.edit_wallet_data')"></div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="wallet_title" v-text="$t('wallets.label.wallet_title')"></label>
                    <input class="form-control" id="wallet_title" name="wallet_title"
                           v-model="edit_form_data.wallet_title">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="password"
                           v-text="$t('label.current_wallet_password')"
                    ></label>
                    <div class="row">
                        <div class="col-1">
                            <button class="form-control"
                                    style="width: fit-content"
                                    type="button"
                                    @click="togglePassword('edit_form')"
                            >
                                <i class="fas fa-eye"></i>
                            </button>
                        </div>
                        <div class="col-11">
                            <input name="password"
                                   :type="password_type_edit_form"
                                   id="password"
                                   class="form-control"
                                   v-model="edit_form_data.password"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label>
                        <span v-text="$t('label.access_ips_for_webservice')"></span>
                        <span v-text="$t('label.optional_input')" class="mx-1"></span>
                    </label>
                    <button type="button"
                            class="btn btn-primary pl-2 pr-0 py-1 my-0 mx-1"
                            @click="addIp"
                            v-if="edit_form_data.access_ips.length < 10"
                    >
                        <i class="fas fa-plus"></i>
                    </button>
                    <button type="button"
                            class="btn btn-danger pl-2 pr-0 py-1 my-0 mx-1"
                            @click="removeIp"
                            v-if="edit_form_data.access_ips.length > 1"
                    >
                        <i class="fas fa-minus"></i>
                    </button>
                    <div v-for="(access_ip, index) in edit_form_data.access_ips"
                         :key="index"
                         class="mb-2"
                    >
                        <input :id="`access_ips.${index}`"
                               :name="`access_ips.${index}`"
                               class="form-control"
                               dir="ltr"
                               v-model="edit_form_data.access_ips[index]"
                        >
                    </div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="wallet_title" v-text="$t('wallets.label.wallet_display_name')"></label>
                    <select id="display_name"
                            name="display_name"
                            class="form-control kt-selectpicker"
                            v-model="edit_form_data.wallet_display_name">
                        <option :value="user_full_name">
                            {{ user_full_name }}
                        </option>
                        <option :value="edit_form_data.wallet_title">
                            {{ edit_form_data.wallet_title }}
                        </option>
                    </select>
                </div>
                <div class="col-12 mt-4">
                    <button class="btn btn-success" @click="updateWallet()" type="button"
                            v-text="$t('btn.submit_changes')"></button>
                </div>
            </div>
        </form>
    </main-content>
</template>

<script>
import mainContent from "@/components/main-content";
import $ from "jquery";
import {authService, walletService} from "@/common/api.service";
import {i18n} from "@/plugins/i18n";
import {mapGetters} from "vuex";
import PasswordModal from '@/components/elements/modal/password-modal.vue';
import Approve from '@/components/elements/modal/otp-modal.vue';
import { TwoFactorType } from '@/constants/TwoFactorType';
import otpModal from '@/components/elements/modal/otp-modal.vue';

export default {
    components: { otpModal, Approve, PasswordModal, mainContent},
    data() {
        return {
            settlement_two_factor_setting: false,
            initial_settlement_two_factor_setting: false,
            settlement_with_paya_when_bank_disable: false,
            settlement_setting_loading: false,
            show_sms_verify: false,
            old_password_type: 'password',
            new_password_type: 'password',
            password_type_edit_form: 'password',
            form_data: {
                old_password: '',
                new_password: '',
                sms_verify: null,
                opt: null,
            },
            edit_form_data: {
                wallet_title: '',
                access_ips: [''],
                password: '',
                wallet_display_name: '',
            },
            api_key: '',
            sign_key: '',
            refresh_token: '',
            wallet_password: '',
            modal_wallet_password: '',
            two_factor_type: null,
            inquiry_key: '',
            refresh_inquiry_key: '',
        };
    },
    computed: {
        ...mapGetters('user', ['current_user']),
        user_full_name() {
            return this.current_user.first_name + ' ' + this.current_user.last_name;
        }
    },
    mounted() {
        this.getApiKey();
    },
    methods: {
        settlementSettingAction() {

            let param = {
                settlement_with_paya_when_bank_disable: this.settlement_with_paya_when_bank_disable,
                settlement_two_factor_setting: this.settlement_two_factor_setting,
            };
            if (this.settlement_two_factor_setting == false && this.initial_settlement_two_factor_setting){
                $('#password_modal').modal('show')
                return;
            }

            this.settlement_setting_loading = true;

            walletService.setSettlementSetting(this.$route.params.hashid, param).then(({data}) => {
                this.toastr.success(data.message);
                this.initial_settlement_two_factor_setting = this.settlement_two_factor_setting
            }).catch(({response}) => {
                console.log(response)
                this.toastr.error(response.data.message);
                this.showMsg($('#settlement_setting'), response.data.message)
            }).finally(() => {
                this.settlement_setting_loading = false;
            })


        },
        getApiKey() {
            walletService.getApiKey(this.$route.params.hashid).then(res => {
                this.api_key = res.data.data.api_key;
                this.sign_key = res.data.data.sign_key;
                this.refresh_token = res.data.data.refresh_token;
                this.edit_form_data.wallet_title = res.data.data.wallet_title;
                this.edit_form_data.access_ips = res.data.data.access_ips;
                this.edit_form_data.wallet_display_name = res.data.data.wallet_display_name;
                this.settlement_with_paya_when_bank_disable = res.data.data.settlement_settings.settlement_with_paya_when_bank_disable;
                this.settlement_two_factor_setting = res.data.data.settlement_settings.settlement_two_factor_setting;
                this.initial_settlement_two_factor_setting = res.data.data.settlement_settings.settlement_two_factor_setting;
                this.inquiry_key = res.data.data.inquiry_key;
                this.refresh_inquiry_key = res.data.data.refresh_inquiry_key;
            });
        },
        addIp() {
            if (this.edit_form_data.access_ips.length < 10) {
                this.edit_form_data.access_ips.push('');
            }
        },
        removeIp() {
            this.edit_form_data.access_ips.pop();
        },
        updateWallet() {
            let form = $('#edit_data_form');

            form.validate({
                rules: {
                    wallet_title: {
                        required: true,
                    },
                    password: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                return;
            }

            let params = {
                access_ips: this.edit_form_data.access_ips,
                wallet_title: this.edit_form_data.wallet_title,
                password: this.edit_form_data.password,
                display_name: this.edit_form_data.wallet_display_name,
            };

            walletService.editWalletData(params, this.$route.params.hashid).then(res => {
                this.showMsg(form, 'success', i18n.t('label.data_successfully_changed'));
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message);
            });
        },
        regenerateApiKey() {
            let form = $('#sign_key_form');

            walletService.regenerateApiKey(this.$route.params.hashid).then(res => {
                this.showMsg(form, 'success', res.data.message);

                this.api_key = res.data.data.api_key;
            });
        },
        regenerateSignKey() {
            let form = $('#sign_key_form');

            walletService.generateNewSignKey(this.$route.params.hashid).then(res => {
                this.showMsg(form, 'success', res.data.message);
                this.sign_key = res.data.data.sign_key;
            });
        },
        regenerateInquiryKey() {
            let form = $('#sign_key_form');

            walletService.regenerateInquiryKey(this.$route.params.hashid).then(res => {
                this.showMsg(form, 'success', res.data.message);

                this.inquiry_key = res.data.data.inquiry_key;
            });
        },
        togglePassword(value) {
            if (value === 'old_password') {
                this.old_password_type = this.old_password_type === 'password' ? 'text' : 'password';
            }

            if (value === 'new_password') {
                this.new_password_type = this.new_password_type === 'password' ? 'text' : 'password';
            }

            if (value === 'edit_form') {
                this.password_type_edit_form = this.password_type_edit_form === 'password' ? 'text' : 'password';
            }
        },
        forgetPassword() {
            let form = $('#password_form');
            let phone = this.$store.state.user.current_user.phone;

            let verify = {
                phone,
            };

            authService.sendVerifyWallet(verify).then(res => {
                this.show_sms_verify = true;
                this.showMsg(form, 'success', res.data.message);
            });
        },
        changePassword() {
            let form = $('#password_form');

            form.validate({
                rules: {
                    new_password: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                return;
            }

            let params = {
                old_password: this.form_data.old_password,
                new_password: this.form_data.new_password,
                wallet_hashid: this.$route.params.hashid,
                sms_verify: this.form_data.sms_verify,
            };

            walletService.changePassword(params).then(res => {
                this.$router.push('/wallets');
            }).catch(({response}) => {
                if (response.data.data) {
                    let message = '';

                    for (let [key, value] of Object.entries(response.data.data)) {
                        for (let error of value) {
                            message += error;
                            message += '<br>';
                        }
                    }

                    this.showMsg(form, 'danger', message);
                } else {
                    this.showMsg(form, 'danger', response.data.message);
                }
            });
        },
        setWalletPasswordAndSendOtp(pass){
            this.modal_wallet_password = pass;
            this.sendCode()
        },
        setOtp(data) {
            let param = {
                settlement_with_paya_when_bank_disable: this.settlement_with_paya_when_bank_disable,
                settlement_two_factor_setting: this.settlement_two_factor_setting,
                two_factor_type: !this.two_factor_type ? '': this.two_factor_type,
                otp: data,
            };
            this.settlement_setting_loading = true;
            walletService.setSettlementSetting(this.$route.params.hashid, param).then(({data}) => {
                this.toastr.success(data.message);
                this.initial_settlement_two_factor_setting = this.settlement_two_factor_setting
                $('#approve_modal').modal('hide')
            }).catch(({response}) => {
                console.log(response)
                this.toastr.error(response.data.message);
                this.showMsg($('#settlement_setting'), response.data.message)
            }).finally(() => {
                this.settlement_setting_loading = false;
            })
        },
        sendRequest(type) {
            this.two_factor_type = type;
            if (type === TwoFactorType.SMS) {
                this.sendCode()
            }
        },
        sendCode(){
            let params = {
                wallet_id: this.$route.params.hashid,
                password: this.modal_wallet_password,
                two_factor_type: this.two_factor_type,
            }
            walletService.sendVerificationCode(params).then(response => {
                this.two_factor_type = response.data.data.two_factor_type;
                $('#password_modal').modal('hide');
                $('#approve_modal').modal('show')
                this.toastr.success(response.data.message);
            }).catch(({response}) => {
                console.log(response);
                this.toastr.error(response.data.message);
            })
        }
    },
}
</script>

<style scoped>
.back-flex {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
}
</style>
